import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconBookmarkLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={fill}
        d="m10 14.552-3.308 1.42c-.502.214-.979.173-1.43-.124-.453-.297-.679-.715-.679-1.253V4.423c0-.42.146-.777.438-1.069a1.454 1.454 0 0 1 1.069-.437h7.82c.421 0 .777.146 1.07.437.29.292.437.648.437 1.07v10.17c0 .54-.226.957-.678 1.254-.452.297-.93.338-1.431.123L10 14.551Zm0-1.385 3.806 1.64a.238.238 0 0 0 .245-.025.25.25 0 0 0 .116-.216V4.423a.244.244 0 0 0-.08-.176.245.245 0 0 0-.177-.08H6.09a.245.245 0 0 0-.176.08.245.245 0 0 0-.08.176v10.143c0 .09.038.163.116.216a.238.238 0 0 0 .244.024L10 13.167Zm0-9H5.833h8.334H10Z"
      />
    </Svg>
  );
};

export default IconBookmarkLine;
